import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in Franklin, TN?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through a post office in Franklin typically takes 1–2 months, especially during the busy spring and summer travel seasons. For Cool Springs executives, Williamson County families, and healthcare professionals, that timeline is simply not viable when international travel is imminent.",
  },
  {
    q: "Does Franklin, TN have a passport agency?",
    a: "Franklin does not have its own passport agency. The closest regional passport agency for Franklin residents is the Atlanta Passport Agency at 801 Broadway, Nashville, TN 37203 — approximately 20 miles north via I-65. This facility handles same-day and emergency appointments, but public appointment availability is limited and competitive. Fast Passport Center provides expedited processing through reserved courier access, so Franklin travelers don't need to race for a public appointment.",
  },
  {
    q: "Can Cool Springs corporate executives get passports quickly?",
    a: "Absolutely — and this is one of the most common scenarios we handle in the Franklin area. Executives at MARS Petcare, Community Health Systems, Tractor Supply, Asurion, and other Cool Springs companies often need passport renewals with very short notice when an international meeting is confirmed. Start online, ship your documents overnight from your Franklin office or home, and we handle the rest. Most renewals process in 2–9 business days.",
  },
  {
    q: "What if my passport expires before my Caribbean cruise?",
    a: "This is a very common situation for Spring Hill and Brentwood families who book cruise deals and then discover a passport validity issue. Most cruise lines require your passport to be valid for at least six months beyond your return date. If your passport is expiring within six months of your cruise departure, expedite immediately. Standard post office processing in Williamson County can take 1–2 months — far too long for an upcoming sailing.",
  },
  {
    q: "How do I get a child's first passport in Franklin, TN?",
    a: "Minors under 16 must apply in person at an acceptance facility with both parents present (or one parent with a notarized consent form if the other cannot attend). Franklin-area acceptance facilities include the Franklin Main Post Office, the Brentwood Post Office, and Spring Hill Post Office. We provide a complete checklist so Franklin families know exactly what to bring to avoid a wasted trip.",
  },
  {
    q: "Can I renew my passport without visiting a Franklin area post office?",
    a: "Yes — if your most recent passport was issued when you were 16 or older, was issued within the last 15 years, is undamaged, and was issued in your current name (or you have documentation of a name change), you can renew by mail without visiting an acceptance facility. Start your order online, follow our checklist, and ship your documents overnight from any FedEx or UPS location in the Franklin area.",
  },
  {
    q: "Where can I get passport photos in Franklin, TN?",
    a: "Passport photos are available throughout the Franklin and Brentwood area. CVS on Columbia Avenue, Walgreens on Mack Hatcher Memorial Pkwy, the FedEx Office in Cool Springs, and numerous UPS Store locations throughout Williamson County offer passport photo services. We recommend verifying with the photo technician that your photos meet the 2x2 inch, white background U.S. State Department standard before submitting your application.",
  },
  {
    q: "How do I get a passport for international travel from BNA?",
    a: "BNA Nashville International Airport is approximately 20 miles from Franklin via I-65 and serves direct international flights to London Heathrow, Cancún, Montego Bay, Toronto, and seasonal European destinations. You must have a valid passport before checking in for any international flight from BNA — and many destinations require six months of validity beyond your return date. If your departure is within two to three weeks, start with Fast Passport Center immediately.",
  },
  {
    q: "Is Fast Passport Center an official government agency?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing through reserved courier submission availability, at prices typically 30–100% lower than FedEx, Staples, and other third-party resellers.",
  },
];

export default function FranklinTNFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Franklin and Williamson County travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i
                    className={`text-white text-sm transition-transform duration-200 ${
                      openIndex === i ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}